import clsx from "clsx"
import { FC, ReactNode } from "react"
import styles from "./NewsBar.module.css"

type NewsBarProps = {
  title: string
  primaryButton?: ReactNode
  secondaryButton?: ReactNode
  background?: string
  fullWidth?: boolean
  textColor?: string
}
export const NewsBar: FC<NewsBarProps> = ({
  title,
  primaryButton,
  secondaryButton,
  background,
  fullWidth,
  textColor = "text-neutral-white",
}) => {
  return (
    <div
      className={clsx(styles["newsbar-container"], fullWidth ? styles["newsbar-full"] : styles["newsbar-default"])}
      style={{ background: background ?? "linear-gradient(90deg, #7DACF7 75.5%, #F670C7 100%)" }}
    >
      <div className={styles["newsbar-title-wrap"]}>
        <p className={clsx(styles["newsbar-title"], textColor)}>{title}</p>
      </div>
      <div className={styles["newsbar-buttons-container"]}>
        {secondaryButton}
        {primaryButton}
      </div>
    </div>
  )
}
